export default __webpack_public_path__ + "static/media/Hemkunskap10.38e8b193.jpeg";